import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a6b983cb648b900140a589c_1787687340944_29049dfe/tranceformright/src/components/Chatbot.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a6b983cb648b900140a589c_1787687340944_29049dfe/tranceformright/src/styles/index.css");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a6b983cb648b900140a589c_1787687340944_29049dfe/tranceformright/src/styles/tailwind.css");
